import c from './app-pagination.vue';

export default c;
